import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SharedModule as PrimeSharedModule } from 'primeng/api';
import { DragRangeCalendarComponent } from './drag-range-calendar.component';
import { TopScrollbarDirective } from './top-scrollbar.directive';

const DECLARATIONS = [DragRangeCalendarComponent, TopScrollbarDirective];

@NgModule({
  declarations: DECLARATIONS,
  imports: [CommonModule, OverlayPanelModule, PrimeSharedModule],
  exports: DECLARATIONS,
})
export class RangeKitModule {}
